import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import AppContext from "../context/Context";
import apiURL from "../services/apiURL";
// const browser = detect();

const useAxios = (configParams) => {
  const [res, setRes] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  const { loginUserDetails, accessToken } = useContext(AppContext);
  debugger;

  axios.defaults.baseURL = apiURL();

  useEffect(() => {
    fetchDataUsingAxios(configParams);
  }, []);

  //   configParams = {
  //     url: "/todos/2",
  //     method: "get",
  //     body: {},
  //     params: {},
  //     headers: {},
  //   };

  configParams["headers"] = {
    Authorization: "Bearer " + accessToken,
    "Content-Type": "application/json",
  };
  configParams["headers"]["Authorization"] = "Bearer " + accessToken;
  configParams["headers"]["Content-Type"] = "application/json";


  const fetchDataUsingAxios = async () => {
    await axios
      .request(configParams)
      .then((res) => setRes(res))
      .catch((err) => setErr(err))
      .finally(() => setLoading(false));
  };

  return { res, err, loading };
};
export default useAxios;
